import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=d085e1a0&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/frontend/home.scss?vue&type=style&index=0&id=d085e1a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d085e1a0",
  null
  
)

export default component.exports